import PropTypes from 'prop-types';
import { sanitize } from '../../../../../common/services/sanitizer/service';

export const name = 'sanitize';
export const propType = PropTypes.bool;
export const defaultProp = true;
export const onParse = sanitize;
